import { createMonitoringApi } from "@soft-db/monitoring-api-client";
import { useAuthStore } from "../stores";
import { http } from "./http";

export const monitoringApi = createMonitoringApi({
	http,
	tokenProvider: () => useAuthStore().getAuthToken(),
	socketEndpoint: import.meta.env.VITE_WS_URL ?? "",
});
